import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SalesOffersResultSchema } from '../schemas';
import { authHeader, salesApiBaseUrl } from './authHeader';
export const offersApi = createApi({
    reducerPath: 'offersApi',
    baseQuery: fetchBaseQuery({
        baseUrl: salesApiBaseUrl(),
        prepareHeaders: async (headers) => {
            const auth = await authHeader();
            Object.entries(auth).forEach(([key, value]) => headers.set(key, value));
            return headers;
        }
    }),
    endpoints: builder => ({
        // POST /offers/search — the request body (property, dates, guests, promo /
        // corporate code) is the cache key, so changing the code re-fetches offers.
        searchOffers: builder.query({
            query: request => ({
                url: '/offers/search',
                method: 'POST',
                body: request
            }),
            transformResponse: (response) => SalesOffersResultSchema.parse(response)
        })
    })
});
export const { useLazySearchOffersQuery } = offersApi;
